<template>
  <div class="homeht">
    <div class="hometop">
      <div class="toptxt">
        <h4 style="margin-left: 40px; text-align: left">策略研发平台</h4>
        <p style="margin-left: 40px">开源、可视化</p>
        <div style="width: 1005px">
          <div
            v-for="(item1, index1) in bak1"
            :key="index1"
            class="topkua"
            @click="goto1(index1)"
          >
            <img :src="bak1[index1]" alt="" />
            <h4>{{ tit1[index1] }}</h4>
            <p>{{ txt1[index1] }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="homebo">
      <div class="botxt">
        <h5><common-data name="appShortName_37"/><common-data name="appFullName_37"/></h5>
        <p>文华财经旗下星格研究所的旗舰产品之一，面向专业投资机构，提供集成化、全流程的量化策略开发工具。</p>

        <p>
          作为多因子估值数据库的量化应用示范平台，支持量化多头策略、市场中性策略、可转债策略的研发，提供了包括编写因子、可视化策略构建、回测报告、收益归因分析等功能。
        </p>
        <p>另外，<common-data name="appShortName_37"/>提供实用性的股票投资策略案例。</p>
        <!-- <a
          href="https://www.wenhua.com.cn/popwin/wh10ldjx.html"
          target="_blank"
          class="turnto"
          >wh11量化功能亮点解析</a
        >
        <router-link
          to="/news"
          style="display: block"
          class="link"
          target="_blank"
          >媒体报道</router-link
        > -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cen: {
        cen1: false,
        cen2: false,
        cen3: false,
      },
      bak1: {
        cen1: [require("../../assets/img/yzk.png")],
        // cen2: [require("../../assets/img/xg.png")],
        // // cen3: [require("../../assets/img/ldcl.png")],
        // cen4: [require("../../assets/img/cta.png")],
        // cen7: [require("../../assets/img/kzz.png")],
        // cen5: [require("../../assets/img/zhyh1.png")],
        // cen8:[require("../../assets/img/数据.png")],
        cen10:[require("../../assets/img/icon.png")],
        cen9:[require("../../assets/img/案例.png")],
      },
      tit1: {
        cen1: "开源因子库",
        cen2: "多因子选股策略量化",
        cen3: "行业轮动策略量化",
        cen4: "商品CTA策略",
        cen7: "可转债策略量化",
        cen5: "组合优化",
        cen8: "另类数据",
        cen9: "策略案例",
        cen10:"可视化策略构建平台"
      },
      bg1: {
        cen1: "【开发背景】一般不甚熟悉财务报表科目的投资者，即使通读财报也难以清晰认知企业。",
        cen2: "【开发背景】企业粉饰财务报表往往主要是在会计准则允许的范围内调节资产负债表和利润表数据。",
        cen3: "【开发背景】绝大多数投资者选股时往往只关心净利润，忽视了现金流。但相对于利润的“纸上富贵”，现金流才是企业“真金白银”，且造假更加困难。",
      },
      txt1: {
        cen1: "软件提供估值数据、量价类、财务类、盈利预测、持股结构等十几大类的133个开源因子，用户可查看Python代码，还可以直接使用，通过可视化界面快速构建自己的策略",
        cen2: "丰富的因子库，点击鼠标即实现量化多头、市场中性等策略；多样化组合、多维度报告，构建最优策略组合。",
        cen3: "量化行业轮动，助您把握行业涨跌节奏、洞悉结构化行情，赚取行业超额收益。",
        cen4: "商品多因子量化，使用多因子策略对商品期货进行资产定价研究，构建最优商品投资组合。",
        cen7: "研判可转债生命周期并过滤高风险的可转债，使用转债及正股多因子对可转债进行定价研究；多维度的回测报告、多种策略优化工具，助力可转债策略研发。",
        cen5: "追求收益最大化的个股权重分配工具，可在一定约束条件下，以综合因子得分最大化为目标，自动构建最优持仓组合。",
        cen8: "软件还提供政策、技术和社会面事件挖掘得到的事件概念数据，通过股票市场法估值数据获得的股票估值水平数据，通过高频分钟线数据挖掘得到的日内高信息增益数据等，用于编写独特视角的另类因子，全面捕捉市场的动态和复杂性",
        cen9: "基于估值数据库的策略案例，年化收益率20%，同时持仓100支股票，理论上可以管理10亿级别的基金。也提供市场中性以及可转债策略等多种策略。",
        cen10: "可视化界面，后台应用智能化、自适应技术做数据处理，省略客户的各种设置操作，让用户快速构建自己的策略"
      },
      go: {
        cen1: "3",
        cen2: "4",
        cen3: "6",
      },
      go2:{
        cen1: "6",
        cen8: "0",
        cen9: "5",
        cen10: "1",
      },
      go1: {
        cen1: "0",
        cen2: "1",
        cen3: "2",
        cen4: "3",
        cen7: "7",
        cen5: "5",
        cen8: "1",
        cen9: "5"
      },
      anmi1: "",
      anmi2: "",
      anmi3: "",
      ifpc: true,
    };
  },
  methods: {
    goto(idx) {
      var id = this.go[idx];
      var newpage = this.$router.resolve({
        path: `/featurepack/${id}`,
      });
      window.open(newpage.href, "_blank");
    },
    goto1(idx) {
      var id = this.go2[idx];
      var newpage = this.$router.resolve({
        path: `/plantform/${id}`
      });
      if((/Mobi|Android|iPhone/i.test(navigator.userAgent))){
        this.$router.push(`/plantform/${id}`)
      }
      else{
        window.open(newpage.href, "_blank");
      }
    },
    show(id) {
      this.cen[id] = true;
    },
    hide(id) {
      this.cen[id] = false;
    },

    showhi(idx) {
      Object.keys(this.cen).forEach((item) => {
        this.cen[item] = false;
      });
      this.cen[idx] = true;
    },
  },
  mounted() {
    // this.set1();
    // this.set2();
    // this.set3();
  },
  created() {
    if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
      this.ifpc = false;
    } else {
      this.ifpc = true;
    }
  },
};
</script>

<style>
.homeht {
  margin-top: 72px;
  background: white;
}
.hometop {
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=52) no-repeat top;
  height: 808px;
}
.homecen {
  /* background: url(../../assets/img/lianghua_bg.jpg) no-repeat center; */
  height: 551px;
}
.homebo {
  background:  url(../../assets/img/about_01.jpg) no-repeat top,url(../../assets/img/about_02.jpg) no-repeat bottom;
  height: 262px;
  margin-top: 21px;
}
.botxt {
  width: 930px;
  margin: 0 auto;
  padding-top: 50px;
  padding-left: 40px;
}
.homeht h5 {
  font-size: 16px;
  color: #5a100d;
  line-height: 30px;
  font-weight: bold;
  padding-bottom: 5px;
}
.botxt p {
  text-indent: 2em;
  line-height: 20px;
  /* padding: 5px 0 0 0; */
  font-size: 14px;
  text-align: justify;
  color: #717171;
}
.centxt {
  width: 1020px;
  margin: 0 auto;
  padding-top: 22px;
}
.centxt h4 {
  font-size: 22px;
  text-align: left;
  color: #5a100d;
  line-height: 35px;
  font-weight: bold;
  margin-left: 40px;
}
.centxt p {
  text-align: left;
  font-size: 14px;
  color: #a57b62;
  margin-left: 40px;
}
.cenhover {
  width: 1020px;
  margin: 0 auto;
  height: 230px;
  /* padding-top: 31px; */
}
.cenhover .sa {
  width: 285px;
  margin: 11px 28px 11px 27px;
  float: left;
  height: 282px;
  filter: drop-shadow(0 2px 6px #cbb8aa);
  cursor: pointer;
  position: relative;
}
.sa h4 {
  color: #d61d3f;
  font-size: 20px;
  padding-top: 24px;
  text-align: center;
}
.sa p {
  color: #a38c72;
  font-size: 14px;
  padding: 10px 20px;
  text-align: justify;
}
.sa .xiangqing {
  position: absolute;
  left: 20px;
  bottom: 35px;
  color: #a38c72;
  font-size: 14px;
}
.black {
  height: 100%;
  width: 100%;
  background: #c1a695;
  opacity: 0.8;
}
.black h4 {
  color: white;
  font-size: 20px;
  padding-top: 14px;
  text-align: center;
}
.black p {
  text-indent: 2em;
  color: white;
  font-size: 14px;
  padding: 15px;
  text-align: justify;
}
.black div {
  width: 85px;
  border: 1px solid white;
  color: white;
  height: 30px;
  margin: 0 auto;
  line-height: 30px;
  cursor: pointer;
  border-radius: 10px;
  font-size: 14px;
  text-align: center;
}
.black div:hover {
  color: #c1a695;
  background: white;
  border: 1px solid #c1a695;
}
.toptxt {
  padding-top: 450px;
  width: 1020px;
  margin: 0 auto;
}
.topkua {
  width: 255px;
  margin: 35px 40px 20px 40px;
  display: inline-block;
  position: relative;
  cursor: pointer;
  text-align: center;
  vertical-align: top;
}
.toptxt h4 {
  font-size: 22px;
  text-align: center;
  color: #5a100d;
  line-height: 35px;
  font-weight: bold;
}
.toptxt p {
  text-align: left;
  font-size: 14px;
  color: #a57b62;
}
.topkua h4 {
  font-size: 22px;
  text-align: center;
  color: #b12a42;
  line-height: 35px;
  font-weight: bold;
  margin: 6px 0;
}
.topkua p {
  text-align: left;
  font-size: 14px;
  color: #705a41;
  margin-top: 5px;
  text-align: justify;
}
.cc {
  height: 200px;
  position: relative;
  z-index: 22222;
  cursor: pointer;
}
.topkua img {
  /* padding-left: 25px; */
  z-index: 222;
}
.dcl {
  background: url(../../assets/img/chilun-b.png) no-repeat center;
  position: absolute;
  height: 98px;
  width: 98px;
  top: 20px;
  left: 20px;
  z-index: auto;
  transform: rotate(0deg);
  -ms-transform: rotate(0deg); /* IE 9 */
  -moz-transform: rotate(0deg); /* Firefox */
  -webkit-transform: rotate(0deg); /* Safari 和 Chrome */
  -o-transform: rotate(0deg); /* Opera */
}
.xcl {
  background: url(../../assets/img/chilun-s.png) no-repeat center;
  position: absolute;
  width: 34px;
  height: 34px;
  transform: rotate(0deg);
  -ms-transform: rotate(0deg); /* IE 9 */
  -moz-transform: rotate(0deg); /* Firefox */
  -webkit-transform: rotate(0deg); /* Safari 和 Chrome */
  -o-transform: rotate(0deg); /* Opera */
}
.bianb {
  position: absolute;
  height: 30px;
  width: 30px;
  top: 70px;
  left: 200px;
  background: url(../../assets/img/bianb-s.png) no-repeat center;
}
.sousuo {
  position: absolute;
  height: 70px;
  width: 70px;
  top: 20px;
  left: 25px;
}
.ssli {
  background: url(../../assets/img/bianb-b.png) no-repeat center;
  height: 56px;
  width: 56px;
  float: right;
  margin-top: 13px;
}
.duihao {
  background: url(../../assets/img/dui.png) no-repeat left;
  height: 52px;
  width: 52px;
  position: absolute;
  top: 30px;
  left: 55px;
}
.money {
  background: url(../../assets/img/qian.png) no-repeat center;
  height: 40px;
  width: 40px;
  position: absolute;
  top: 70px;
  left: 200px;
}
.turnto {
  color: #0000ff;
  line-height: 50px;
  font-size: 14px;
}
.turnto:visited {
  color: #0000ff;
}
.link {
  color: #0000ff;
  font-size: 14px;
}
.link:visited {
  color: #0000ff;
}
</style>